<template>
  <footer>
    <SimpleNavigation
      v-if="kql.site?.content?.main_navigation"
      :pagelist="kql.site.content.main_navigation"
    />
    <SimpleNavigation
      v-if="kql.site?.content?.footer_navigation"
      :pagelist="kql.site.content.footer_navigation"
    />
  </footer>
</template>

<script setup>
import { useStore } from '@/KQL.js'
import SimpleNavigation from './SimpleNavigation.vue'

const kql = useStore()
</script>

<style scoped>
@import '@/css/breakpoints.css';

footer {
  position: relative;
  display: flex;
  justify-content: space-between;
  left: 0;
  right: 0;
  z-index: 1;
  padding-top: 5rem;
  padding-left: 2rem;
  padding-right: 2rem;
  padding-bottom: 3rem;
  box-sizing: border-box;
}

@media (--narrow) {
  footer {
    display: block;
    columns: 1;
    column-gap: 2rem;
  }

  footer :deep(.simple-navigation) {
    display: block;
    margin-bottom: 0rem;
    break-inside: avoid;
  }

  footer :deep(.nav-button) {
    display: block;
    text-align: left;
    margin-bottom: 0rem;
  }
}

</style>
